<template>
  <div class="home">
    <div class="content">
      <div class="container-fluid">
        <router-link to="/selecione">
          <div class="col-12 btn-voltar">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-rewind" viewBox="0 0 16 16">
              <path d="M9.196 8 15 4.633v6.734zm-.792-.696a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z"/>
              <path d="M1.196 8 7 4.633v6.734zm-.792-.696a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z"/>
            </svg>
            VOLTAR
          </div>
      </router-link>

        <div class="col-12 pt-4">
          <h1 class="titillium-web-bold">Tarefa Solidária Jogos Interclasse</h1>
          <h4 class="titillium-web-light">Acompanhe os resultados da arrecadação de alimentos!</h4>
        </div>
        <div class="row pt-4">
        <h1 class="titillium-web-bold pb-2" v-if="this.$route.params.classe && this.$route.params.classe.startsWith('EF')">
            {{ this.$route.params.classe.charAt(2) }}º ANO
        </h1>


          
          <div class="col-4" v-for="classe in classes" :key="classe.nome" @click="redirectToProfile(classe)">
            <div class="holder-salas"  v-if="!loading_percent">
              <div class="sala titillium-web-bold text-center pt-2">{{ classe }}</div>
              <div class="descricao-sala text-center titillium-web-semibold">meta da turma</div>
              <div class="porcentagem text-center titillium-web-bold pt-2">
                
                {{ classes_percent[classe] !== undefined ? Math.floor(classes_percent[classe]) + '%' : '0%' }}

              </div>

              <div class="percent-donate"
                  :class="{
                      'blue-bg': ((classes_percent[classe]) >= 0 && (classes_percent[classe]) < 40),
                      'yellow-bg': ((classes_percent[classe]) >= 40 && (classes_percent[classe]) < 75),
                      'green-bg': ((classes_percent[classe])>= 75)
                  }"
                  :style="{ height: (classes_percent[classe] != null ? classes_percent[classe] + '%' : '0%') }"
              ></div>

              <div class="circle-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z"/>
                </svg>
              </div>
            </div>
            <div v-else class="text-center p-4">
              <div class="spinner-border text-light" role="status">
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $firebase } from '../services/firebase'

export default {
  data() {
    return {
      server: "http://localhost:8080",
      email: "",
      password: "",
      loading: false,
      error: false,
      msg_error: "",
      donates: [],
      classes: {},
      all_metas: [],
      meta_sala: {},
      arrecadacao_sala: {},
      classes_percent:{},
      loading_percent: true
    };
  },
  methods: {
    async fetchDonates() {
      try {
        const snapshot = await $firebase.database().ref('donates').once('value');
        const donatesObject = {};
        snapshot.forEach(childSnapshot => {
          let somaQuantidade = 0;
          childSnapshot.forEach(childDate => {
            childDate.forEach(childID => {
              somaQuantidade += childID.val().quantidade;
            });
          });
          donatesObject[childSnapshot.key] = somaQuantidade;
        });
        this.donates = donatesObject;
      } catch (error) {
        console.error('Erro ao buscar doações:', error);
      }
    },
    async fetchClasses() {
      try {
        const snapshot = await $firebase.database().ref('classes').once('value');
        const classesArray = [];
        snapshot.forEach(childSnapshot => {
         
          if (childSnapshot.key.includes(this.$route.params.classe)) {
            classesArray.push(childSnapshot.key);
          }
        });
        this.classes = classesArray;
        return classesArray;
      } catch (error) {
        console.error('Erro ao buscar classes:', error);
        throw error;
      }
    },
    async fetchMetas() {
      try {
        const snapshot = await $firebase.database().ref('metas').once('value');
        const somaMetas = {};
        snapshot.forEach(childSnapshot => {
          let somaMeta = 0;
          const metasClasse = childSnapshot.val();
          for (const produto in metasClasse) {
            if (Object.prototype.hasOwnProperty.call(metasClasse, produto)) {
              somaMeta += metasClasse[produto].meta;
            }
          }
          somaMetas[childSnapshot.key] = somaMeta;
        });
        this.all_metas = somaMetas;
      } catch (error) {
        console.error('Erro ao buscar metas:', error);
        throw error;
      }
    },
    async metasDetails() {
      try {
        let classeFilter = 0;
        if (this.$route.params.classe == "EF6") {
          classeFilter = 16;
        } else if (this.$route.params.classe == "EF7") {
          classeFilter = 17;
        } else if (this.$route.params.classe == "EF8") {
          classeFilter = 18;
        } else if (this.$route.params.classe == "EF9" ) {
          classeFilter = 19;

        }else{
          classeFilter = 18;
        }
        const snapshot = await $firebase.database().ref('metas/' + classeFilter).once('value');
        const meta_sala = {};
        snapshot.forEach(childSnapshot => {
          meta_sala[childSnapshot.key] = childSnapshot.val().meta;
        });
        this.meta_sala = meta_sala;
      } catch (error) {
        console.error('Erro ao buscar metas:', error);
        throw error;
      }
    },
    async donatesDetails() {
      try {
        const snapshot = await $firebase.database().ref('donates').once('value');
        const arrecadacao_sala = {};

        snapshot.forEach(childSnapshot => {
          // Inicializa o objeto aninhado com a chave childSnapshot.key se ainda não existir
          if (!arrecadacao_sala[childSnapshot.key]) {
            arrecadacao_sala[childSnapshot.key] = {};
          }

          childSnapshot.forEach(childSnapDate => {
            childSnapDate.forEach(childSnapProduto => {
              const produto = childSnapProduto.val().produto;
              const quantidade = childSnapProduto.val().quantidade;

              // Verifica se o produto já foi adicionado à sala
              if (!arrecadacao_sala[childSnapshot.key][produto]) {
                // Se não, inicializa sua quantidade como 0
                arrecadacao_sala[childSnapshot.key][produto] = 0;
              }

              // Adiciona a quantidade ao objeto aninhado
              arrecadacao_sala[childSnapshot.key][produto] += quantidade;
            });
          });
        });

        // Atualiza a variável arrecadacao_sala com o objeto criado
        this.arrecadacao_sala = arrecadacao_sala;
      } catch (error) {
        console.error('Erro ao buscar doações:', error);
      }
    },


    async calculaConsultas() {
      try {
        const porcentagensArray = {};
        if (this.arrecadacao_sala && typeof this.arrecadacao_sala === 'object') {
          // Itera sobre as chaves do objeto arrecadacao_sala
          for (const key in this.arrecadacao_sala) {
            // Verifica se a chave é uma propriedade do objeto
            if (key in this.arrecadacao_sala) {
              // Exibe a chave principal
              const innerObject = this.arrecadacao_sala[key];

              // Verifica se o objeto aninhado está definido e é um objeto
              if (innerObject && typeof innerObject === 'object') {
                porcentagensArray[key] = {};

                // Itera sobre as chaves do objeto aninhado
                for (const innerKey in innerObject) {
                  // Verifica se a chave é uma propriedade do objeto aninhado
                  if (innerKey in innerObject) {
                    var porcentagemProduto = (innerObject[innerKey]* 100) / this.meta_sala[innerKey]

                    if(porcentagemProduto > 100){
                      porcentagensArray[key][innerKey] =  100 
                    }else{
                      porcentagensArray[key][innerKey] = porcentagemProduto;

                    }
                    porcentagensArray[key][innerKey] = porcentagemProduto;


                    // console.log("Produto: "+innerKey+" /  META GERAL "+this.meta_sala[innerKey]+" ARRECADADO "+innerObject[innerKey]+ "Porcent "+porcentagemProduto+"%")

                  }
                }
              }
            }
          }
        }



        const allProdutosSala = {};
        for (let produto in this.meta_sala) {
          if (Object.prototype.hasOwnProperty.call(this.meta_sala, produto)) {
            let quantidade = this.meta_sala[produto];
            allProdutosSala[produto] = quantidade;
          }
        }

        var arrayFinal = {}
        this.classes.forEach(objetcClasse =>{
         arrayFinal[objetcClasse] = allProdutosSala
        })

        
        for (const obj in arrayFinal) {
            var qtdArray = 0;
            var somaPorcentes = 0;

            // Verifica se porcentagensArray[obj] está definido
            if (porcentagensArray[obj]) {

                for (const produto in arrayFinal[obj]) {
                    if (porcentagensArray[obj][produto] !== undefined && porcentagensArray[obj][produto] !== "") {
                        // console.log("Produto:" + produto + " Porcentagem:" + porcentagensArray[obj][produto]);
                        somaPorcentes += porcentagensArray[obj][produto];
                        qtdArray++;
                    } else {
                        qtdArray++;
                    }
                }

                // Verifica se qtdArray é maior que zero para evitar divisão por zero
                if (qtdArray > 0) {
                    this.$set(this.classes_percent, obj, somaPorcentes / qtdArray);
                    // console.log(" SOMA PORCENTAGEM " + somaPorcentes + " qtd array " + qtdArray + " Resultado Final " + obj + " ---- " + (somaPorcentes / qtdArray));
                } else {
                    console.log("Nenhuma porcentagem definida para " + obj);
                }
            } else {
                console.log(" ");
            }
        }
        this.loading_percent = false





      } catch (error) {
        console.error('Erro:', error);
      }
    },
    redirectToProfile(classe) {
      this.$router.push({ name: 'ArrecadacaoSala', params: { classe: classe } });
    }

  },
  async mounted() {
    try {
      // await this.fetchDonates();
      await this.fetchClasses();
      // await this.fetchMetas();
      await this.metasDetails();
      await this.donatesDetails();
      this.calculaConsultas();
    } catch (error) {
      console.error('Erro ao montar o componente:', error);
    }
  }
};
</script>
